// AUTO-GENERATED from prompts/flux-render.yaml.

export interface FluxStyle { id: string; label: string; base: string; swatches: readonly string[]; }

export interface FluxRoomCue { kind: string; cue: string; }

export interface FluxSize { id: string; label: string; width: number; height: number; }

export const FLUX_MODEL = "flux1-schnell-fp8.safetensors";

export const FLUX_PHOTOGRAPHIC_BASE = "professional interior design photograph, architectural photography, natural daylight pouring through tall windows, soft directional shadows, golden hour warmth, photorealistic, 8K, ultra-detailed, sharp focus, depth of field, shot on Hasselblad H6D, shallow DOF, tasteful magazine spread composition, AD Magazine, Dwell, Elle Decor.";

export const FLUX_NEGATIVE_BASE = "cartoon, illustration, painting, low quality, blurry, watermark, text, logo, distorted proportions, oversaturated, fisheye, overexposed, cluttered, harsh fluorescent lighting, motion blur.";

export const FLUX_STYLES: readonly FluxStyle[] = [
  {
    "id": "scandi-indo",
    "label": "Scandi · Indo-modern",
    "base": "Scandinavian-Indo modern interior, light oak floors, warm white walls, bouclé seating, handloom textiles, brass accent details, indoor plants, jute and rattan, large rugs, calm and uncluttered.",
    "swatches": [
      "#F3EBDD",
      "#C7A47A",
      "#7A6C5A",
      "#3B2E25"
    ]
  },
  {
    "id": "indian-traditional",
    "label": "Indian traditional",
    "base": "Traditional Indian interior, jaali screens, mughal arch motifs, teak wood furniture, brass utensils, marigold and saffron accents, vintage tiles, oil-rubbed bronze, hanging lanterns, rich textiles.",
    "swatches": [
      "#E5BE7C",
      "#A14A2F",
      "#5B2A1E",
      "#1F2233"
    ]
  },
  {
    "id": "modern-minimal",
    "label": "Modern minimal",
    "base": "Modern minimal interior, monochrome palette, clean lines, micro-cement floor, full-height glazing, statement pendant, negative space, ash wood, off-white linen, brushed steel.",
    "swatches": [
      "#F8F6F2",
      "#D6D2CB",
      "#8C8985",
      "#1B1B1B"
    ]
  },
  {
    "id": "japandi",
    "label": "Japandi",
    "base": "Japandi interior, Japanese minimalism meets Scandinavian warmth, tatami rug, shoji screen, charred-wood accent wall, low platform seating, ceramic vases with single branch, paper lantern lighting.",
    "swatches": [
      "#EEEAE3",
      "#B9A88C",
      "#665344",
      "#2B2218"
    ]
  },
  {
    "id": "industrial-loft",
    "label": "Industrial loft",
    "base": "Industrial loft interior, exposed brick, blackened steel framing, concrete ceiling, edison-bulb pendants, reclaimed wood, leather seating, vintage metal furniture, polished concrete floor.",
    "swatches": [
      "#C9B79A",
      "#6D5B4E",
      "#3B2F26",
      "#1A1614"
    ]
  }
];

export const FLUX_ROOM_CUES: readonly FluxRoomCue[] = [
  {
    "kind": "living",
    "cue": "spacious living room, low slung sofa, accent armchair, coffee table styled with books and ceramics, bookcase, rug grounding the seating arrangement, soft layered lighting."
  },
  {
    "kind": "master-bedroom",
    "cue": "serene master bedroom, upholstered headboard, linen bedding, bedside reading lamps, walk-in wardrobe glimpse, layered curtains, calming palette."
  },
  {
    "kind": "kids-bedroom",
    "cue": "warm kids bedroom, bunk bed with soft railings, study nook, pinboard with art, soft rug, plush toys arranged tastefully, no clutter."
  },
  {
    "kind": "kitchen",
    "cue": "modular kitchen with quartz countertop, soft-close cabinetry, brass tap, pendant lights over island, ventilation hidden, mood of effortless cooking."
  },
  {
    "kind": "puja-room",
    "cue": "intimate puja room with carved wooden panel backdrop, brass diya lamps, marigold strings, soft warm light, white marble floor, single accent stool."
  },
  {
    "kind": "dining",
    "cue": "modern dining with ten-seater table, sculptural pendant, statement art on wall, layered textures, candle glow, food styled subtly on table."
  }
];

export const FLUX_SIZES: readonly FluxSize[] = [
  {
    "id": "portrait",
    "label": "Portrait · social",
    "width": 832,
    "height": 1216
  },
  {
    "id": "landscape",
    "label": "Landscape · moodboard",
    "width": 1216,
    "height": 832
  },
  {
    "id": "square",
    "label": "Square · pinterest",
    "width": 1024,
    "height": 1024
  }
];
